import { normalizeSymbols } from "./normalizeSymbols";
import { normalizeUnicodeSubSup } from "./normalizeUnicodeSubSup";

// Normalizes text before it is parsed into math nodes (paste, LaTeX input, …):
//   1. normalizeSymbols maps keyboard look-alikes (e.g. AZERTY ˆ → ^) so they
//      are recognized. It must run first so its output feeds the sub/sup pass
//      as a real caret (e.g. "xˆ²" → "x^²" → "x^{2}").
//   2. normalizeUnicodeSubSup folds unicode super/subscripts (², ₃, …) into the
//      ^{…} / _{…} forms the parser understands.
export function normalizeMathText(text: string): string {
  return normalizeUnicodeSubSup(normalizeSymbols(text));
}
